import React from "react";
import { Box } from "@mui/material"; // or your Box component

function formatSince(ms) {
  if (!Number.isFinite(ms)) return "";
  const totalSec = Math.floor(ms / 1000);

  if (totalSec < 60) return "just now";

  const totalMin = Math.floor(totalSec / 60);
  if (totalMin < 60) return `${totalMin}m ago`;

  const hours = Math.floor(totalMin / 60);
  return `${hours}h ${totalMin % 60}m ago`;
}

function useNow(tickMs = 1000) {
  const [now, setNow] = React.useState(() => Date.now());
  React.useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [tickMs]);
  return now;
}

export default function LastUpdateTimer({ lastUpdate }) {
  const now = useNow(1000);

  const last = React.useMemo(() => {
    const v = lastUpdate;
    if (!v) return NaN;
    if (v instanceof Date) return v.getTime();
    if (typeof v === "number") return v < 1e12 ? v * 1000 : v; // sec→ms
    const t = Date.parse(v);
    return Number.isNaN(t) ? NaN : t;
  }, [lastUpdate]);

  const since = formatSince(now - last);

  return (
    <Box style={{ fontSize: 14, color: "gray", marginLeft: 5, width: 70 }}>
      {since}
    </Box>
  );
}